 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		92: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		92: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "static/js/" + ({"18":"App2DPaymentComplete","19":"AppPayment","20":"AppPaymentComplete","21":"AppPaymentProcessing","22":"AxsTravelInsure","23":"BusinessProtect360.Generate","24":"CILeadForm","25":"CIP.FactFormApp","26":"CIProtect360.Dashboard","27":"CIProtect360.Details","28":"CIProtect360.Direct.Generate","29":"CIProtect360.Generate","30":"CampaignLeadForm","31":"CarProtect360","32":"CashCardShield","33":"ChoicesProtect360","34":"CommissionStatement","35":"Common.Error","36":"Common.MyInfoCallback","37":"ComplimentaryHomeContents","38":"ConsumerPortal","39":"ContactUs","40":"CorporateTravel","41":"CrossBorderProtectWithUpgrade","42":"Debug","43":"EMAPortal","44":"EarlyProtect360Plus","45":"EarlyProtect360Plus.Dashboard","46":"EarlyProtect360Plus.Details","47":"FamilyProtect360","48":"FamilyProtectLiteWithUpgrade","49":"FilipinoBond","50":"FlashPayShieldWithUpgrade","51":"FraudProtect360","52":"HIProtect360Protect360","53":"HomeProtect360","54":"HomeProtectLite","55":"HomeSafe","56":"HomeStarterKit","57":"InternalDemoCookie","58":"KeymanProtect360","59":"KeymanProtect360.Dashboard","60":"KeymanProtect360.Details","61":"LeadForm","62":"Loan Protect 360 Renewal","63":"LoanProtect360","64":"LoanProtect360.Dashboard","65":"LoanProtect360.Details","66":"MaidProtect360","67":"MotoringCardShieldWithUpgrade","68":"Motorshow2020","69":"PartnerProgram","70":"PhoneProtect360","71":"PowerAgentPortal","72":"Prestige","73":"Prestige.Secured","74":"PublicHousingAssured","75":"ReviewUs","76":"SBSTPAProtectLite","77":"SBSTPAProtectPlus","78":"SBSTTravelInsurance","79":"SOA","80":"SimplyGo","81":"SingaporeTravelPass","82":"Touristcard","83":"TravelAssured","84":"TravelAssuredPlus","85":"TravelProtect360","86":"TravelProtect360Plus","87":"cileadform","88":"currencyconverter","89":"freehomeinsurance","91":"motorshow","93":"transferprotect360pro","94":"vCashCard","95":"weather"}[chunkId]||chunkId) + "." + {"0":"adcfc880","1":"15413d96","2":"d32d25bf","3":"5ce9e49b","4":"3993626c","5":"95297c0f","6":"d39c503d","7":"af59b3e0","8":"c8eae2de","9":"3d686a44","10":"3b94b543","11":"3e3eacfe","12":"be425841","13":"7ca1abae","14":"955382c7","15":"fdb6cd43","16":"70075c71","17":"7b05aef2","18":"89ecccdc","19":"3fb3b92f","20":"ba840bd6","21":"f53a0957","22":"d90555ca","23":"875c5808","24":"7a4eb1a8","25":"8b6b4dcd","26":"bccb535b","27":"8019ceaa","28":"fb02a5f4","29":"af555feb","30":"70a43dc9","31":"08950e37","32":"0dae2c38","33":"9e697167","34":"54701344","35":"af2d540f","36":"da87834a","37":"29d0995b","38":"416050d9","39":"5adbe0fe","40":"b0698d5e","41":"d8d0df54","42":"90094794","43":"d2184c17","44":"ace9939f","45":"de1aa17c","46":"42b1cc66","47":"2f6c5bbd","48":"5017ecb3","49":"15e80b0d","50":"bedaf892","51":"c7fba47a","52":"09112c8b","53":"8172fcab","54":"5f5a0f89","55":"a10d11f4","56":"dbc52b99","57":"56791835","58":"0f3a1b3d","59":"764b5838","60":"b22eec22","61":"3439db7f","62":"cb896edf","63":"f2b36d6e","64":"414dfd80","65":"953e92a8","66":"35d32acc","67":"4a4feb54","68":"d9c2d2c0","69":"2e9bf502","70":"bdf888d3","71":"27e7d53c","72":"032fbc73","73":"8f7827bf","74":"a7311e05","75":"be4a7fe6","76":"36f2669c","77":"79f86c55","78":"4ee49153","79":"dd6d19b3","80":"757b892f","81":"942b30e2","82":"2417955a","83":"361c4f18","84":"5dbc4384","85":"6552a1a0","86":"b2aac016","87":"6a606637","88":"9fc83cc0","89":"81c73d1c","91":"a63f3d83","93":"9fce57d9","94":"bd161fb8","95":"9c67a0e3","97":"a4549873","98":"d319a311","99":"8c77c582","100":"94f07fb1","101":"23eb4e95","102":"69e0e4bc","103":"6ff7f10d","104":"e13dd4a5","105":"824762a7","106":"a8f36497","107":"d7bad2b7","108":"86e05d22","109":"dda92c92","110":"e6e7f5ea","111":"9c0403b5","112":"b3b3ef2c","113":"6b2a29a9","114":"a51705ee","115":"90d8a718","116":"85b4702c","117":"6ba8edba","118":"614c2784","119":"48c9208b","120":"e66ffb85","121":"a1b55ecc","122":"43ebe5c8","123":"add4906d","124":"920f4d3f","125":"54a7ae06","126":"3ea2deab","127":"82db9b7a","128":"0403c19c","129":"ef4690dd","130":"dc7c0c6d","131":"54329ba7","132":"f1d76712","133":"d6ac8149","134":"2a313fa1","135":"66b5ffa7","136":"70aa22f5","137":"8ce236ec","138":"1da8c16c","139":"25a99e23","140":"e93c1dee","141":"feb2533c","142":"55e28a72","143":"f0a777d5","144":"61916753","145":"97fc6307","146":"576000ed","147":"6734ef85","148":"ef3e3dc9","149":"307ffd4d","150":"fe21f4fb","151":"2e8b9c9d","152":"ab297b5d","153":"b7deb807","154":"ee56e74b","155":"ba8c6ad8","156":"307762bb","157":"85d2812b","158":"ed6b46a5","159":"7460406a","160":"6c13aeea","161":"65efba3a","162":"d95afdeb","163":"c75220bd","164":"087e5498","165":"4a8e4e64","166":"d5a3596d","167":"a2915669","168":"9f6e4e0c","169":"09127454","170":"c8b4ea7f","171":"e20b2511","172":"75883ab7","173":"b3891741","174":"4a2d26d3","175":"704ea9db","176":"854f09f8","177":"46241cf3","178":"fd0fd439"}[chunkId] + ".chunk.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"19":1,"21":1,"22":1,"23":1,"25":1,"28":1,"30":1,"31":1,"32":1,"33":1,"34":1,"37":1,"38":1,"40":1,"41":1,"42":1,"44":1,"47":1,"48":1,"49":1,"50":1,"51":1,"52":1,"53":1,"54":1,"55":1,"56":1,"58":1,"61":1,"66":1,"67":1,"69":1,"70":1,"71":1,"72":1,"73":1,"74":1,"76":1,"77":1,"78":1,"79":1,"80":1,"81":1,"82":1,"83":1,"84":1,"85":1,"86":1,"87":1,"88":1,"89":1,"91":1,"93":1,"94":1,"95":1,"98":1,"99":1,"101":1,"102":1,"103":1,"104":1,"105":1,"106":1,"107":1,"108":1,"109":1,"110":1,"113":1,"117":1,"121":1,"122":1,"126":1,"127":1,"131":1,"132":1,"133":1,"134":1,"135":1,"136":1,"137":1,"138":1,"139":1,"140":1,"141":1,"142":1,"143":1,"144":1,"156":1,"157":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "static/css/" + ({"18":"App2DPaymentComplete","19":"AppPayment","20":"AppPaymentComplete","21":"AppPaymentProcessing","22":"AxsTravelInsure","23":"BusinessProtect360.Generate","24":"CILeadForm","25":"CIP.FactFormApp","26":"CIProtect360.Dashboard","27":"CIProtect360.Details","28":"CIProtect360.Direct.Generate","29":"CIProtect360.Generate","30":"CampaignLeadForm","31":"CarProtect360","32":"CashCardShield","33":"ChoicesProtect360","34":"CommissionStatement","35":"Common.Error","36":"Common.MyInfoCallback","37":"ComplimentaryHomeContents","38":"ConsumerPortal","39":"ContactUs","40":"CorporateTravel","41":"CrossBorderProtectWithUpgrade","42":"Debug","43":"EMAPortal","44":"EarlyProtect360Plus","45":"EarlyProtect360Plus.Dashboard","46":"EarlyProtect360Plus.Details","47":"FamilyProtect360","48":"FamilyProtectLiteWithUpgrade","49":"FilipinoBond","50":"FlashPayShieldWithUpgrade","51":"FraudProtect360","52":"HIProtect360Protect360","53":"HomeProtect360","54":"HomeProtectLite","55":"HomeSafe","56":"HomeStarterKit","57":"InternalDemoCookie","58":"KeymanProtect360","59":"KeymanProtect360.Dashboard","60":"KeymanProtect360.Details","61":"LeadForm","62":"Loan Protect 360 Renewal","63":"LoanProtect360","64":"LoanProtect360.Dashboard","65":"LoanProtect360.Details","66":"MaidProtect360","67":"MotoringCardShieldWithUpgrade","68":"Motorshow2020","69":"PartnerProgram","70":"PhoneProtect360","71":"PowerAgentPortal","72":"Prestige","73":"Prestige.Secured","74":"PublicHousingAssured","75":"ReviewUs","76":"SBSTPAProtectLite","77":"SBSTPAProtectPlus","78":"SBSTTravelInsurance","79":"SOA","80":"SimplyGo","81":"SingaporeTravelPass","82":"Touristcard","83":"TravelAssured","84":"TravelAssuredPlus","85":"TravelProtect360","86":"TravelProtect360Plus","87":"cileadform","88":"currencyconverter","89":"freehomeinsurance","91":"motorshow","93":"transferprotect360pro","94":"vCashCard","95":"weather"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0","1":"31d6cfe0","2":"31d6cfe0","3":"31d6cfe0","4":"31d6cfe0","5":"31d6cfe0","6":"31d6cfe0","7":"31d6cfe0","8":"31d6cfe0","9":"31d6cfe0","10":"31d6cfe0","11":"31d6cfe0","12":"31d6cfe0","13":"31d6cfe0","14":"31d6cfe0","15":"31d6cfe0","16":"31d6cfe0","17":"31d6cfe0","18":"31d6cfe0","19":"a858c2f5","20":"31d6cfe0","21":"a858c2f5","22":"86c9f98d","23":"d30bc41f","24":"31d6cfe0","25":"d33f62d9","26":"31d6cfe0","27":"31d6cfe0","28":"58058363","29":"31d6cfe0","30":"05f863ac","31":"ddf1f108","32":"04bc7233","33":"ddf1f108","34":"d33f62d9","35":"31d6cfe0","36":"31d6cfe0","37":"0e4fba13","38":"978e5247","39":"31d6cfe0","40":"ac3f861f","41":"0e4fba13","42":"5d27deaa","43":"31d6cfe0","44":"58058363","45":"31d6cfe0","46":"31d6cfe0","47":"ddf1f108","48":"0e4fba13","49":"ddf1f108","50":"0e4fba13","51":"ddf1f108","52":"ddf1f108","53":"471a3a57","54":"471a3a57","55":"471a3a57","56":"0e4fba13","57":"31d6cfe0","58":"58058363","59":"31d6cfe0","60":"31d6cfe0","61":"dd9a60e3","62":"31d6cfe0","63":"31d6cfe0","64":"31d6cfe0","65":"31d6cfe0","66":"14284125","67":"0e4fba13","68":"31d6cfe0","69":"8b647349","70":"471a3a57","71":"716aad65","72":"2fc531d7","73":"cdec5a50","74":"471a3a57","75":"31d6cfe0","76":"39dd3a27","77":"e81d10c5","78":"86c9f98d","79":"d33f62d9","80":"98c15efc","81":"2e8fdc12","82":"344cc04e","83":"86c9f98d","84":"86c9f98d","85":"2e8fdc12","86":"86c9f98d","87":"22b92479","88":"7b4f34de","89":"0e4fba13","91":"49234f01","93":"14284125","94":"94b03ce8","95":"23255cb6","97":"31d6cfe0","98":"cce35a68","99":"440606be","100":"31d6cfe0","101":"2d576837","102":"166c8acc","103":"db5d06da","104":"f93319e8","105":"f93319e8","106":"72c6f688","107":"72c6f688","108":"72c6f688","109":"f93319e8","110":"72c6f688","111":"31d6cfe0","112":"31d6cfe0","113":"6f6df1fe","114":"31d6cfe0","115":"31d6cfe0","116":"31d6cfe0","117":"6f6df1fe","118":"31d6cfe0","119":"31d6cfe0","120":"31d6cfe0","121":"6f6df1fe","122":"6f6df1fe","123":"31d6cfe0","124":"31d6cfe0","125":"31d6cfe0","126":"4b48318c","127":"4b48318c","128":"31d6cfe0","129":"31d6cfe0","130":"31d6cfe0","131":"4b48318c","132":"4b48318c","133":"4b48318c","134":"4b48318c","135":"4b48318c","136":"4b48318c","137":"4b48318c","138":"4b48318c","139":"4b48318c","140":"4b48318c","141":"4b48318c","142":"4b48318c","143":"4b48318c","144":"4b48318c","145":"31d6cfe0","146":"31d6cfe0","147":"31d6cfe0","148":"31d6cfe0","149":"31d6cfe0","150":"31d6cfe0","151":"31d6cfe0","152":"31d6cfe0","153":"31d6cfe0","154":"31d6cfe0","155":"31d6cfe0","156":"5fe6802c","157":"5fe6802c","158":"31d6cfe0","159":"31d6cfe0","160":"31d6cfe0","161":"31d6cfe0","162":"31d6cfe0","163":"31d6cfe0","164":"31d6cfe0","165":"31d6cfe0","166":"31d6cfe0","167":"31d6cfe0","168":"31d6cfe0","169":"31d6cfe0","170":"31d6cfe0","171":"31d6cfe0","172":"31d6cfe0","173":"31d6cfe0","174":"31d6cfe0","175":"31d6cfe0","176":"31d6cfe0","177":"31d6cfe0","178":"31d6cfe0"}[chunkId] + ".chunk.css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://assets.hlas.com.sg/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = this["webpackJsonphlas-react-app"] = this["webpackJsonphlas-react-app"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
